import { render, staticRenderFns } from "./CargaAcademica.vue?vue&type=template&id=b4a3020c&"
import script from "./CargaAcademica.vue?vue&type=script&lang=js&"
export * from "./CargaAcademica.vue?vue&type=script&lang=js&"
import style0 from "./CargaAcademica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports